import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  get_candidate_profile_data_action,
  update_user_meta_data_action,
} from "../../../redux/_actions";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";

function CandidateProfile2(props) {
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState({});
  const [userPrimarySkills, setUserPrimarySkills] = useState([]);
  const [loadingUploadResume, setLoadingUploadResume] = useState(false);

  //get data from redux
  const { userProfileData } = useSelector(
    (state) => state.get_candidate_profile_data_reducer
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    callApi();
  }, []);

  useEffect(() => {
    if (userProfileData?.data) {
      setUserData(userProfileData?.data);
    }
  }, [userProfileData]);

  useEffect(() => {
    if (userProfileData?.data) {
      getUserPrimarySkills(userProfileData?.data);
    }
  }, [userProfileData]);

  const callApi = async () => {
    setLoading(true);
    await dispatch(get_candidate_profile_data_action());
    setLoading(false);
  };

  const getUserPrimarySkills = (data) => {
    let skills = data && data?.skills;

    let results = skills && skills.filter((item) => item?.is_primary === true);

    if (results.length > 0) setUserPrimarySkills(results);
    else setUserPrimarySkills(skills);
  };

  const onEditProfile = () => {
    navigate("/edit-candidate-profile");
  };

  const onShareProfileClick = () => {
    const isDev =
      !process.env.NODE_ENV || process.env.NODE_ENV === "development";
    const url = isDev
      ? `http://localhost:3000/view-candidate-profile/${
          userData?.user_details && userData.user_details?.hash_id
        }`
      : `${process.env.REACT_APP_DEV_ROOT_URL}/view-candidate-profile/${
          userData?.user_details && userData.user_details?.hash_id
        }`;
    window.navigator.clipboard.writeText(url);

    showSuccessMessage(`Url copied ${url}`);
  };

  const onUploadResume = async (e, key) => {
    const file = e.target.files[0];
    const name = e.target.name;
    const data = new FormData();

    data.append(name, file);
    if (file) {
      if (file && file.type === "application/pdf") {
        setLoadingUploadResume(true);
        await dispatch(update_user_meta_data_action(data));
        await dispatch(get_candidate_profile_data_action());
        setLoadingUploadResume(false);
      } else {
        showWarningMessage("Please select a PDF file.");
      }
    }
  };
  return {
    onEditProfile,
    loading,
    userData,
    userPrimarySkills,
    loadingUploadResume,
    onShareProfileClick,
    onUploadResume,
  };
}
export default CandidateProfile2;
